import { createDuck } from '@/utils'
import { getChildAddress } from '@/services/api/address'
import { Toast } from 'antd-mobile-v2'
import { batchGetAddress } from '@/services/api/address'
/**
 * 省份 城市 街道
 */
let globalAddress = {}

export const GLOBAL_ADDRESS_MAP = {
  1: {
    key: 'province',
    text: '省份',
  },
  2: {
    key: 'city',
    text: '城市',
  },
  3: {
    key: 'district',
    text: '区县',
  },
}

const deleteTem = (level, obj) => {
  const res = {}
  const keys = Object.keys(obj)
  for (let i = 0, len = keys.length; i < len; i++) {
    const key = keys[i]
    if (obj[key] && obj[key].type <= level) {
      res[key] = {
        ...obj[key],
      }
    }
  }
  return res
  // return list.filter(item => {
  //   return item.type >= level
  // })
}
const DEFAULT_VALUE = {
  /**
   * 是否显示地址选择弹层
   */
  showAddressSelect: false,

  //选中的地址
  selectedAddress: {},

  //选中过程中的地址
  tempSelectedAddress: {},

  //展示当前可选的地址列表
  addressOptions: [],
  //当前在哪一级省份、城市、区县
  curData: {
    type: 0,
  },
}

export const duck = createDuck({
  name: 'newAddressDuck',
  initialState: { ...DEFAULT_VALUE },
  actions: {
    //初始化地址选择弹层信息
    /**
     * 批量处理
     * @param {object} address  当前选中的地址
     * @returns
     */
    batchFetchAddress(address) {
      return (dispatch, getState) => {
        const { newAddressDuck } = getState()
        const { selectedAddress, curData: cacheData } = newAddressDuck
        let idArr = []
        let curData = { type: 1, parent: 1 }
        let tempSelect = {
          province: { type: 1, parent: 1 },
        }

        if (!globalAddress[1]) {
          idArr.push(1)
        }
        if (address) {
          const { province, city, district } = address

          curData = district
            ? {
                ...district,
              }
            : { ...city }
          tempSelect = { province, city, district }
          if (!globalAddress[province.id]) {
            idArr.push(province.id)
          }
          if (!globalAddress[city.id]) {
            idArr.push(city.id)
          }
        }

        if (selectedAddress.province && selectedAddress.city && selectedAddress.district) {
          tempSelect = { ...selectedAddress }
        }
        //哪些id需要拉数据

        if (cacheData.name) {
          curData = { ...cacheData }
        }
        // const idArr = address ? [1] : [1]
        batchGetAddress(idArr).then(res => {
          const { data, error } = res
          if (!error) {
            globalAddress = {
              ...globalAddress,
              ...data,
            }
            dispatch(
              duck.change({
                curData: { ...curData },
                tempSelectedAddress: { ...tempSelect },
                addressOptions: globalAddress[curData.parent],
              }),
            )
          }
        })
      }
    },

    // initAddressChooseData(data, selectedData) {
    //   return async (dispatch, getState) => {
    //     const _s = Array.isArray(selectedData) ? selectedData : [{ type: 1, parent: 1 }]
    //     const curData = _s[_s.length - 1]
    //     const { newAddressDuck } = getState()
    //     const t = {}
    //     for (let i = 0, len = _s.length; i < len; i++) {
    //       const { type } = _s[i]
    //       t[GLOBAL_ADDRESS_MAP[type].key] = { ..._s[i] }
    //     }
    //     dispatch(
    //       duck.change({
    //         curData: {
    //           ...curData,
    //         },
    //         tempSelectedAddress: { ...t },
    //         // @ts-ignore
    //         addressOptions: data[curData.parent],
    //         globalAddress: {
    //           ...newAddressDuck.globalAddress,
    //           ...data,
    //         },
    //       }),
    //     )
    //   }
    // },

    //改变当前地址选中的位置
    changeAddressTab(data) {
      return async (dispatch, getState) => {
        const { newAddressDuck } = getState()
        const _key = GLOBAL_ADDRESS_MAP[data.type].key
        const _c = newAddressDuck.tempSelectedAddress[_key]

        const t = deleteTem(data.type, newAddressDuck.tempSelectedAddress)
        dispatch(
          duck.change({
            curData: {
              ..._c,
            },
            tempSelectedAddress: { ...t },
            addressOptions: globalAddress[_c.parent],
          }),
        )
      }
    },
    //改变选中的地址
    changeSelectAddress(cur) {
      return async (dispatch, getState) => {
        const { id, type } = cur
        const _key = GLOBAL_ADDRESS_MAP[type].key

        const { newAddressDuck } = getState()
        if (type === 3) {
          dispatch(
            duck.change({
              curData: { ...cur },
              showAddressSelect: false,
              tempSelectedAddress: {},
              selectedAddress: {
                ...newAddressDuck.tempSelectedAddress,
                [_key]: cur,
              },
            }),
          )
          return
        }
        //判断 当前的地址是否加载了
        let curList = globalAddress[id]
        if (!curList) {
          //发请求
          const { error, data } = await getChildAddress(id)
          if (!error) {
            curList = data
          } else {
            Toast.info('获取数据失败')
            return
          }
          globalAddress = {
            ...globalAddress,
            [cur.id]: curList,
          }
        }

        //处理只有二级没有三级地址的情况
        if (Array.isArray(curList) && curList.length === 0) {
          dispatch(
            duck.change({
              curData: { ...cur },
              showAddressSelect: false,
              tempSelectedAddress: {},
              selectedAddress: {
                ...newAddressDuck.tempSelectedAddress,
                [_key]: cur,
              },
            }),
          )
        } else {
          dispatch(
            duck.change({
              addressOptions: curList,
              curData: { ...cur },
              tempSelectedAddress: {
                ...newAddressDuck.tempSelectedAddress,
                [_key]: cur,
              },
            }),
          )
        }
      }
    },

    //地址选择列表是否展示
    changeShowAddress(value) {
      return async dispatch => {
        dispatch(
          duck.change({
            showAddressSelect: value,
          }),
        )
      }
    },

    clearData(all) {
      return async dispatch => {
        dispatch(
          duck.change(
            all
              ? DEFAULT_VALUE
              : {
                  tempSelectedAddress: {},
                  addressOptions: [],
                  curData: {
                    type: 0,
                  },
                },
          ),
        )
      }
    },

    changeGlobalAddress(data, showModal) {
      return async (dispatch, getState) => {
        // const { newAddressDuck } = getState()
        globalAddress = {
          ...globalAddress,
          ...data,
        }
        dispatch(
          duck.change({
            showAddressSelect: showModal,
          }),
        )
      }
    },

    /**
     * 创建地址
     * @param {number} id
     * @returns
     */
    fetchChildAddress(id, showModal) {
      //updateAddress
      return async (dispatch, getState) => {
        const { newAddressDuck } = getState()
        const { error, data } = await getChildAddress(id)
        if (!error) {
          // const { globalAddress } = newAddressDuck
          // console.log('globalAddress -----------', globalAddress)
          globalAddress = {
            ...globalAddress,
            [id]: data,
          }
          dispatch(
            duck.change({
              showAddressSelect: showModal,
            }),
          )

          // dispatch(duck.fetchAddressList())
        } else {
          Toast.info('获取地址失败')
        }
      }
    },
  },
})
